import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useUserFavorite } from '../hooks';
import ImgCasePlaceholder from '../../scss/images/case.svg';
import Item from './items/Item';
import FormatDate from '../home/cases/FormatDate';

interface Props {
  userId: number;
  isUser: boolean;
}

export const ProfileRight: FunctionComponent<Props> = memo(
  ({ userId, isUser }: Props) => {
    const { t } = useTranslation();
    const { data } = useUserFavorite(userId);
    const getCase = data?.getUserFavorite?.getCase;
    const getGame = data?.getUserFavorite?.getGame;

    return (
      <div className="profile-right">
        <div className="cases">
          <div className="case-item" data-rar={getCase?.color}>
            <Link className="load" to={getCase?.getUrl || '/'}>
              <div className="case-item-tooltipes">
                {getCase?.isHit && <div className="case-hit" />}
                {getCase?.isNew && <div className="case-latest" />}
              </div>
              {getCase?.type === 1 && getCase?.getLeft > 0 && (
                <div className="case-item-nums">
                  <div className="case-item-nums-wrap">
                    <span
                      key={'case-item-nums-0'}
                      className="fas fa-bolt icon icon-case-name"
                    />
                    <span key={'case-item-nums-1'} className="red">
                      {getCase?.getLeft}
                    </span>
                    <span key={'case-item-nums-2'}> / </span>
                    <span key={'case-item-nums-3'}>{getCase?.getLimit}</span>
                  </div>
                </div>
              )}
              {getCase?.getDateEnd && <FormatDate getCase={getCase} />}
              <div className="case-item-img">
                {getCase ? (
                  <>
                    <div className="btn-open-case">{t('Open')}</div>
                    <img
                      className="not-hover"
                      src={getCase?.getBackgroundImage}
                      alt={getCase?.getName}
                    />
                    <img
                      className="hover"
                      src={getCase?.getImage}
                      alt={getCase?.getName}
                    />
                  </>
                ) : (
                  <img
                    className="img-default"
                    src={ImgCasePlaceholder}
                    alt=""
                  />
                )}
              </div>
              <div className="case-item-name">
                <span>
                  <div>{t('Favorite case')}:</div>
                  <div>{getCase?.getName || '-'}</div>
                </span>
              </div>
            </Link>
          </div>
        </div>
        <Item getGame={getGame} isUser={isUser} isProfileRight={true} />
      </div>
    );
  },
);
